import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { FormControl, FormHelperText } from "@mui/material";
import { ItemInputProps } from "./ItemInput";

type SelectInputPropsType = {
  value: string;
  selectValues: string[];
} & ItemInputProps;

const SelectInput = (props: SelectInputPropsType) => {
  const {
    value,
    selectValues,
    isDisabled,
    readOnly,
    onInputChange,
    isPartOfPendingChangesList,
    inputWidth,
    errorMessage
  } = props;

  return (
    <FormControl
      variant="outlined"
      error={!!errorMessage}
      sx={{ width: inputWidth || 230 }}
    >
      <Select
        value={value}
        onChange={(e) => {
          if (!readOnly && onInputChange) {
            onInputChange(e.target.value);
          }
        }}
        disabled={isDisabled}
        readOnly={readOnly}
        error={!!errorMessage}
        variant="outlined"
        inputProps={{
          ispartofpendingchangeslist: (
            isPartOfPendingChangesList || false
          ).toString(),
          "aria-readonly": readOnly
        }}
      >
        {selectValues.map((value: string, index: number) => (
          <MenuItem key={`${value}-${index}`} value={value}>
            {value}
          </MenuItem>
        ))}
      </Select>
      {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};
export default SelectInput;
